import { call, put } from 'redux-saga/effects';

import { fetchRatingCoverage } from 'services/shared';

import {
  GET_RATING_COVERAGE_SUCCESS,
  GET_RATING_COVERAGE_ERROR,
} from 'store/shared/ratingCoverage/ratingCoverageAction';

export function* ratingCoverageSaga({ payload }) {
  try {
    const response = yield call(fetchRatingCoverage, payload);
    yield put({ type: GET_RATING_COVERAGE_SUCCESS, payload: response });
  } catch (response) {
    yield put({ type: GET_RATING_COVERAGE_ERROR, payload: response });
  }
}
